function MGContent({ children }) {
  return <div className="content">{children}</div>;
}

MGContent.propTypes = {};

export default MGContent;
